import find from 'lodash/find'
import i18next from 'i18next';
import {ofType} from 'redux-observable'
import {of, timer} from 'rxjs';
import {ajax} from 'rxjs/ajax';
import {catchError, concatMap, exhaustMap, filter, map, mergeMap, switchMap, takeUntil, takeWhile} from 'rxjs/operators'
import {LOCATION_CHANGE} from 'connected-react-router'

import {LOGOUT_REQUEST_SUCCESS} from '../actions/Auth'
import {SHOPS_SELECT_SHOP} from '../actions/Shops'
import {loadBots} from '../thunks/Bots'
import {
    BOT_STATUS_REQUEST_SUCCESS,
    BOTS_REQUEST_START,
    BOTS_REQUEST_SUCCESS,
    botsClearData,
    botsRequestFail,
    botsRequestStart,
    botsRequestSuccess,
    botStatisticRequestFail,
    botStatisticRequestSuccess,
    botStatusRequestFail,
    botStatusRequestSuccess,
    WHATSAPP_LOGOUT_REQUEST_START,
    WHATSAPP_LOGOUT_REQUEST_SUCCESS,
    whatsappLogoutRequestFail,
    whatsappLogoutRequestSuccess,
    whatsappQRCodeRequestFail,
    whatsappQRCodeRequestSuccess,
} from "../actions/Dashboard";

import {
    ADAPTER_STATUS_WAITING,
    BOT_TYPE_WA,
} from '../constants';


const STATUS_UPDATE_INTERVAL = 10000;


export const botsLoadEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOCATION_CHANGE, SHOPS_SELECT_SHOP),
        filter(() => state$.value.Shops.shopsAreInitiallyLoaded
            && state$.value.router.location.pathname.match(/^\/\d+\/dashboard\/?/)),
        map(action => botsRequestStart())
    );

export const botsRequestStartEpic = (action$, state$) =>
    action$.pipe(
        ofType(BOTS_REQUEST_START),
        switchMap(
            () => loadBots()
        ),
        map(response => {
            if (response.response.status === 'ok') {
                return botsRequestSuccess(response.response.result.results);
            } else {
                return botsRequestFail(response.response.errors);
            }
        }),
        catchError(error => {
            return of(botsRequestFail({
                'common': i18next.t('errors.common.request_sent', 'Error sending request'),
            }));
        })
    );

export const botUpdateStatisticEpic = (action$, state$) =>
    action$.pipe(
        ofType(BOTS_REQUEST_SUCCESS),
        map((action) => action.bots),
        concatMap(x => x),
        mergeMap(
            (bot) => {
                return ajax.post(
                    `${process.env.REACT_APP_API_URL}analytics/bot/`,
                    {bot_id: bot.id},
                    {
                        Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                        'Content-Type': 'application/json',
                    }
                )
            }
        ),
        map(response => {
            if (response.response.status === 'ok') {
                return botStatisticRequestSuccess(response.response.result)
            } else {
                return botStatisticRequestFail(response.response.errors);
            }
        }),
        catchError(error => {
            return of(botStatisticRequestFail({
                'common': i18next.t('errors.common.request_sent', 'Error sending request'),
            }));
        }),
    );

export const botPollStatusEpic = (action$, state$) =>
    action$.pipe(
        ofType(BOTS_REQUEST_SUCCESS),
        map((action) => action.bots),
        concatMap(x => x),
        mergeMap((bot) =>
            timer(0, STATUS_UPDATE_INTERVAL)
                .pipe(
                    takeWhile(() => {
                        return state$.value.Bots.bots.find(botsInState => {
                            return botsInState.id === bot.id
                        }) !== undefined
                    }),
                    takeUntil(action$.ofType(LOCATION_CHANGE, SHOPS_SELECT_SHOP)),
                    exhaustMap(() => {
                            return ajax.get(
                                `${process.env.REACT_APP_API_URL}bot/bot/${bot.id}/status/`,
                                {
                                    Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                                    'Content-Type': 'application/json',
                                }
                            ).pipe(catchError(error => of({
                                response: {
                                    errors: i18next.t('errors.common.request_sent', 'Error sending request')
                                }
                            })));
                        }
                    ),
                    map(response => {
                        if (response.response.status === 'ok') {
                            return botStatusRequestSuccess(response.response.result);
                        } else {
                            return botStatusRequestFail(bot.id, response.response.errors);
                        }
                    }),
                    catchError(error => {
                        return of(botStatusRequestFail(bot.id, {
                            'common': i18next.t('errors.common.request_sent', 'Error sending request'),
                        }));
                    }),
                )
        ),
    );

export const whatsappGetQRCodeEpic = (action$, state$) =>
    action$.pipe(
        ofType(BOT_STATUS_REQUEST_SUCCESS, WHATSAPP_LOGOUT_REQUEST_SUCCESS),
        filter((action) => {
            let bot_id = action.bot_id || action.result.bot_id;
            let bot = find(state$.value.Bots.bots, {id: bot_id});

            return bot && bot.bot_type === BOT_TYPE_WA && bot.adapter_status === ADAPTER_STATUS_WAITING;
        }),
        concatMap(
            (action) => {
                return ajax.get(
                    `${process.env.REACT_APP_SERVICE_CORE_URL}whatsapp/get_qr/${action.result.bot_id}`,
                    {
                        Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                        'Content-Type': 'application/json',
                    },
                )
            }
        ),
        map(response => {
            if (response.response.status === 'ok') {
                return whatsappQRCodeRequestSuccess(response.response.result)
            } else {
                return whatsappQRCodeRequestFail(response.response.result)
            }

        }),
        catchError(error => {
            return of(whatsappQRCodeRequestFail({
                'common': i18next.t('errors.common.request_sent', 'Error sending request'),
            }));
        }),
    );

export const whatsappLogoutRequestStartEpic = (action$, state$) =>
    action$.pipe(
        ofType(WHATSAPP_LOGOUT_REQUEST_START),
        switchMap(
            (action) => {
                return ajax.get(
                    `${process.env.REACT_APP_SERVICE_CORE_URL}whatsapp/logout/${action.bot_id}`,
                    {
                        Authorization: `Bearer  ${state$.value.Auth.authToken}`,
                        'Content-Type': 'application/json',
                    }
                )
            }
        ),
        map(response => {
            if (response.response.status === 'ok') {
                return whatsappLogoutRequestSuccess(response.response.result)
            } else {
                return whatsappLogoutRequestFail(response.response.result)
            }
        }),
        catchError(error => {
            return of(whatsappLogoutRequestFail({
                'common': i18next.t('errors.common.request_sent', 'Error sending request'),
            }));
        }),
    );

export const botsClearDataEpic = (action$, state$) =>
    action$.pipe(
        ofType(LOGOUT_REQUEST_SUCCESS),
        map(botsClearData)
    );
